import { useState } from 'react';
import { makeStyles } from '@mui/styles';

import { Button } from 'common/button';
import DocumentUploadModal from 'pages/common/document/document-upload-modal';
import { NotificationSeverity, showToast } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  button: {
    padding: '10px',
  },
}));

type Props = {
  estateWorkItemId: string;
  portalId: string;
  folderId: string;
  refetchEstateWorkItems: () => void;
};

const EstateWorkItemRequestDocumentForSignature = ({
  estateWorkItemId,
  portalId,
  folderId,
  refetchEstateWorkItems,
}: Props) => {
  const classes = useStyles();

  const [showDocumentUploadModal, setShowDocumentUploadModal] = useState(false);

  return (
    <>
      <Button
        onClick={() => setShowDocumentUploadModal(true)}
        size="small"
        color="info"
        className={classes.button}
      >
        Upload for Signature
      </Button>

      <DocumentUploadModal
        showModal={showDocumentUploadModal}
        setShowModal={setShowDocumentUploadModal}
        portalId={portalId}
        onUploadComplete={() => {
          setShowDocumentUploadModal(false);
          refetchEstateWorkItems();
          showToast({
            message: 'Your file has been uploaded.',
            severity: NotificationSeverity.SUCCESS,
          });
          return;
        }}
        parentId={folderId}
        estateWorkItemId={estateWorkItemId}
      />
    </>
  );
};

export default EstateWorkItemRequestDocumentForSignature;
